import { useEffect } from 'react';

export const usePreventBackButton = () => {
  useEffect(() => {
    window.history.pushState(null, null, window.location.pathname);

    const handleBackButton = () => {
      window.history.pushState(null, null, window.location.pathname);
    };
    window.addEventListener('popstate', handleBackButton);
    
    return () => {
      window.removeEventListener('popstate', handleBackButton);
    };
  }, []);
}; 